export const CreatenewWallsetIcon = (
  <svg width="61" height="61" fill="none" xmlns="http://www.w3.org/2000/svg" className="origin-top-left scale-[0.68]">
    <rect
      x=".1"
      y=".1"
      width="60"
      height="60"
      rx="16"
      fill="#4141F1"
      fillOpacity=".1"
    />
    <path
      opacity=".4"
      d="M34.3 20.1h-8.4c-3.6 0-5.8 2.2-5.8 5.8v8.4c0 3.6 2.2 5.8 5.8 5.8h8.4c3.6 0 5.8-2.2 5.8-5.8v-8.4c0-3.6-2.2-5.8-5.8-5.8Z"
      fill="#FE2C3D"
    />
    <path
      d="M36 29.3h-5.2v-5.2c0-.4-.3-.8-.7-.8-.4 0-.8.4-.8.8v5.2h-5.2c-.4 0-.8.4-.8.8s.4.7.8.7h5.2v5.3c0 .4.4.7.8.7s.7-.3.7-.7v-5.3h5.3c.4 0 .7-.3.7-.7 0-.4-.3-.8-.7-.8Z"
      fill="#FE2C3D"
    />
  </svg>
)
